import { render } from "./BorderCard.vue?vue&type=template&id=07c4cec5"
import script from "./BorderCard.vue?vue&type=script&lang=ts"
export * from "./BorderCard.vue?vue&type=script&lang=ts"
script.render = render

export default script